import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { select, Store } from '@ngrx/store';
import { selectAllInvites, selectInvitesLoading } from 'src/app/store/selectors/invite.selectors';
import * as InviteActions from 'src/app/store/actions/invite.actions';

@Component({
  selector: 'invites-page',
  styleUrls: ['./invites.component.scss'],
  templateUrl: './invites.component.html',
})
export class InvitesComponent implements OnInit {

  invites$: Observable<any[]>;
  invitesLoading$: Observable<boolean>;

  breadcrumbItems = [
    { url: '/', title: 'Início' },
    { url: '/indique', title: 'Indique Allya' },
    { title: 'Meus Convites' },
  ];

  constructor(
    private store: Store
  ) {}

  ngOnInit() {
    this.invites$ = this.store.pipe(select(selectAllInvites));
    this.invitesLoading$ = this.store.pipe(select(selectInvitesLoading));

    this.store.dispatch(InviteActions.retrieve());
  }
}
